import GoogleMapsLoader from 'google-maps';

import styles from './styles.json';

export default class BrixMap {
  static init(...parameters) {
    return new BrixMap(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.tabletMode = false;

    // Check if state has changed otherwise do not change map options and position.
    this.isParentTablet = null;

    // Map center point has two states
    this.mapCenterPoint = null;
    // this.setupListeners();
    this.onReady();
  }

  setupListeners() {
    // console.log('setupListeners');
    // window.addEventListener('DOMContentLoaded', () => {
    //   console.log('DOMContentLoaded');
    //   this.onReady();
    // }, false);
    window.addEventListener('resize', () => this.onResize());
  }

  onReady() {
    this.mapContainer = this.block.querySelector('.map');
    this.initMap();
  }

  initMap() {
    GoogleMapsLoader.KEY = this.mapContainer.dataset.key;
    GoogleMapsLoader.load(google => this.mapLoaded(google));
  }

  mapLoaded(google) {
    this.google = google;
    const mapWrapper = this.mapContainer;
    const latF = parseFloat(this.mapContainer.dataset.lat);
    const lngF = parseFloat(this.mapContainer.dataset.lng);
    const zoomInt = parseInt(this.mapContainer.dataset.zoom, 10);
    // const pinColor = this.convertHex(this.container.dataset.pincolor, 1);
    // Avoid svg – will not show in IE 11. Use base64 encoded png.
    const markerIcon = {
      url: 'data:image/png;base64,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',
      scaledSize: new google.maps.Size(66, 66), // scaled size
    };

    const options = {
      zoom: zoomInt,
      center: { lat: latF, lng: lngF },
      mapTypeControl: false,
      scrollwheel: false,
      streetViewControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.ROADMAP,
        mapTypeIds: ['roadmap', 'terrain'],
      },
      styles,
    };
    this.map = new google.maps.Map(mapWrapper, options);

    this.marker = new google.maps.Marker({
      position: { lat: latF, lng: lngF },
      map: this.map,
      icon: markerIcon,
      optimized: false,
    });

    // this.onResize();
  }

  repositionMap() {
    const latF = parseFloat(this.mapContainer.dataset.lat);
    const lngF = parseFloat(this.mapContainer.dataset.lng);
    let options = {};
    if (this.map) {
      if (this.tabletMode) {
        this.mapCenterPoint = {
          lat: latF,
          lng: lngF,
        };
        options = {
          draggable: false,
          zoomControlOptions: {
            position: this.google.maps.ControlPosition.LEFT_TOP,
          },
        };
      } else {
        this.mapCenterPoint = {
          lat: latF,
          lng: lngF,
        };
        options = {
          draggable: true,
          zoomControlOptions: {
            position: this.google.maps.ControlPosition.RIGHT_BOTTOM,
          },
        };
      }
      this.map.setOptions(options);
    }
  }

  onResize() {
    if (window.innerWidth > 1208) {
      this.tabletMode = false;
    } else {
      this.tabletMode = true;
    }

    if (this.isParentTablet) {
      if (this.isParentTablet !== this.tabletMode) {
        this.repositionMap();
      }
    } else {
      this.repositionMap();
    }

    this.map.setCenter(this.mapCenterPoint);
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-map', BrixMap.init);
}
